//  --------------------------------------------------------------------------
//
//  I M P O R T S
//
//  --------------------------------------------------------------------------

import React, { useEffect, useState } from 'react';
import '../../App.css';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

//  images
//  --------------------------------------------

//  classes
//  --------------------------------------------

import { useTranslation } from 'react-i18next';
import Scrollbox from '../../tools/scrollbox';
import PleaseWait from '../../tools/please-wait';
import SidePanel from '../../tools/side-panel';
import SiteIcon from '../../tools/site-icon';
import ComputeSession from '../compute-tiles/compute-session';

//  types
//  --------------------------------------------

import { ComputeServiceType, Site } from '../../utils/types';

//  constants
//  --------------------------------------------

import { SidePanelPosition } from '../../tools/side-panel';

// functions//  constants
//  --------------------------------------------

import { siteName } from '../../utils/functions';

//  --------------------------------------------------------------------------
//
//  R E D U X   S T A T E   M A N A G E M E N T
//
//  --------------------------------------------------------------------------

import { getComputeServices } from '../interactive-sessions/interactive-sessions-actions';

//  ------------------------------------------------------------
//
//  compute-services panel component.
//
//  ------------------------------------------------------------

export default function ComputeServicesPanel(props: {
  sites: Site[];
  maximised?: boolean;
  minimised?: boolean;
  setComputeMaximised?: any;
  flex?: string;
}) {
  //
  // translation function
  const { t } = useTranslation();

  //  --------------------------------------------------------------------------
  //
  //  R E D U X   S T A T E   H A N D L I N G
  //
  //  --------------------------------------------------------------------------

  //  --------------------------------------------------------------------------
  //
  //  D E C L A R A T I O N S
  //
  //  --------------------------------------------------------------------------

  //  --------------------------------------------------------------------------
  //
  //  F U N C T I O N S
  //
  //  --------------------------------------------------------------------------

  //  --------------------------------------------------------------------------
  //
  //  H O O K S
  //
  //  --------------------------------------------------------------------------

  //  --------------------------------------------------------------------------
  //
  //  C O M P O N E N T   C O D E
  //
  //  --------------------------------------------------------------------------

  return (
    <SidePanel
      position={SidePanelPosition.BOTTOM}
      title={t('Launch compute services')}
      maximised={props.maximised ?? true}
      minimised={props.minimised ?? !props.maximised ?? false}
      redux={true}
      setMaximised={props.setComputeMaximised}
      flex={props.flex ?? '1 1'}
      margin={(props.sites.length > 0 ? '10' : '0') + 'px 0px 0px 0px'}
      width="100%"
    >
      <Scrollbox direction="horizontal" flex="1 1" width="100%" flexDirection="column">
        <div
          className="text-colour"
          style={{
            display: 'flex',
            flexDirection: 'row',
            margin: '0px 10px 5px 10px',
          }}
        >
          <b>Note:</b> &nbsp; Data may need to be staged, even if it is already located at
          the indicated site. Staging creates the link to the data in your project/user
          storage area.
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div style={{ flex: '0 0 15px' }} />
          {props.sites.map((site, siteindex) => (
            <div
              key={siteindex}
              className="text-colour"
              style={{
                flex:
                  '0 0 ' +
                  (
                    110 +
                    getComputeServices({
                      site: site,
                    }).length *
                      293
                  ).toString() +
                  'px',
                height: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  flex: '0 0 80px',
                  height: '85px',
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  alignItems: 'center',
                }}
              >
                <SiteIcon site={site} size={55} />
                <div style={{ flex: '1 1', fontSize: '1em' }}>
                  {siteName({ site: site })}
                </div>
              </div>
              <div style={{ flex: '0 0 10px' }} />
              {getComputeServices({
                site: site,
              }).map((item: ComputeServiceType) => (
                <ComputeSession session={item} />
              ))}
            </div>
          ))}
          <div style={{ flex: '0 0 10px' }} />
        </div>
      </Scrollbox>
    </SidePanel>
  );
  //
} // ComputeServicesPanel
